<template>
    <div class="blog-post-card">
        <div class="card">

            <slot name="header">
                <div class="card-header" v-html="header"></div>
            </slot>

            <div class="card-body d-flex flex-column">

                <slot name="body">

                    <slot name="subtitle">
                        <div class="h6 mb-3" v-html="subtitle"></div>
                    </slot>
                    <slot name="tags">
                        <div class="mb-3">
                            <span v-for="(item, tindex) in tags" :key="tindex" :class="tagClass" class="px-2 py-1 rounded small d-tags">{{ item }}</span>
                        </div>
                    </slot>
                    <slot name="date">
                        <div v-if="blog_date" class="small mb-3">
                            <i class="far fa-clock"></i>
                            <span class="text-secondary1 ms-1" :class="blog_date < new Date() ? 'text-danger' : 'text-success'">{{ blog_date.format(dateFormat) }}</span>
                            <span class="fw-bold ms-2">
                                {{ date_diff }}
                            </span>
                        </div>
                    </slot>

                    <slot name="content">
                        <div class="mb-3" v-html="content"></div>
                    </slot>

                    <slot name="links">
                        <div v-if="links.length" class="small d-flex align-items-center d-none1 mt-auto">
                            <!-- <div>
                                <a :href="links[0].link" class="border rounded-circle me-1 py-1 px-2">
                                    <i class="fas fa-angle-left px-11"></i>
                                </a>
                                <a :href="links[links.length-1].link" class="border rounded-circle me-1 py-1 px-2">
                                    <i class="fas fa-angle-right"></i>
                                </a>
                                <span>1 / {{links.length}}</span>
                            </div> -->
                            <div class="ms-auto">
                                <div class="d-avatar-group">
                                    <div class="d-avatar" v-for="(item, pindex) in links" :key="pindex">
                                        <img :src="item.image" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slot>

                </slot>

            </div>

            <slot name="footer">
                <div class="card-footer" v-html="footer"></div>
            </slot>

        </div>
    </div>
</template>


<script>
// import {ref} from 'vue';
import moment from 'moment';

import {G} from '@/_common';


export default {
    name: 'BlogPostCard',
    props: {
        header:{
            type: String,
            default: ''
        },
        subtitle:{
            type: String,
            default: ''
        },
        tags:{
            type: Array,
            default(){
                return [];
            }
        },
        tagClass:{
            type: String,
            default: 'bg-primary text-light'
        },
        date:{
            type: [Date, String],
            default: ''
        },
        dateFormat:{
            type: String,
            default: 'DD MMM YYYY HH:mm:ss'
        },
        dateDiff:{
            type: Object,
            default(){
                return {};
            }
        },
        content:{
            type: String,
            default: ''
        },
        links:{
            type: Array,
            default(){
                return [];
            }
        },
        footer:{
            type: String,
            default: ''
        },
    },
    setup(props) {
        const blog_date = props.date != '' ? moment(typeof(props.date) == 'object' ? props.date : moment(props.date, G.datetime_format['datetime'])) : ''; //.format(G.datetime_format['datetime']) : '';

        const date_diff = G.formatDateDuration(Object.assign({
            obj: moment,
            date: blog_date || '',
            sign: false,
            // short: true,
            // as: 'day',
            // hours: false,
            // minutes: false,
            // seconds: false,
        }, props.dateDiff));

        return {
            blog_date,
            date_diff,
        };
    },
}
</script>


<style lang="scss">
.blog-post-card{
    width: 100%;
    height: 100%;

    .card{
        border: 0px;
        border-radius: 10px;
        padding: 10px;
        height: 100%;
        width: 100%;
    }
    .card-header{
        background-color: unset;
        border: 0px;
        font-size: 1rem;
        font-weight: 600;
    }
    .card-footer{
        background-color: unset;
        border: 0px;
    }

    .d-avatar-group {
        display: flex;
        align-items: center;
    }
    .d-avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        font-size: 1rem;
    }
    .d-avatar-group .d-avatar + .d-avatar {
        margin-left: -1rem;
    }
    .d-avatar img {
        width: 100%;
        height: 100%;
    }

    .d-tags{
        display: inline-block;
        margin-bottom: .2rem;
        margin-right: .2rem;
    }
}
</style>